import React from 'react';
import { CloseButton, ClickLinkDataParamType } from '@rmc/webcx-web-libs';
import styles from './index.module.scss';
import { Image, ImagePropsType } from '../Image';
import { ActionButton, ActionButtonPropsType } from '../ActionButton';
import { Text, TextPropsType } from '../Text';

type CardsPropsType = {
	image: ImagePropsType;
	actionButton: ActionButtonPropsType;
	bodyText: TextPropsType;
	clickLinkData: ClickLinkDataParamType;
	onClick: () => void;
	onClose?: () => void;
	onImgLoad?: () => void;
	style?: React.CSSProperties;
};

export function Card({
	image,
	actionButton,
	bodyText,
	onClick,
	onClose,
	onImgLoad,
	clickLinkData,
	style = {},
}: CardsPropsType) {
	return (
		<div className={styles.card}>
			<CloseButton className={styles.closeButton} onClick={onClose} />
			<Image onImgLoad={onImgLoad} className={styles.image} {...image} />
			<div className={styles.content} style={style}>
				<Text className={styles.text} {...bodyText} />
				<ActionButton
					{...actionButton}
					onClick={onClick}
					clickLinkData={clickLinkData}
				/>
			</div>
		</div>
	);
}
